export default __webpack_public_path__ + "../ckeditor/plugins/link/dialogs/anchor.js";